import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import autoComplete from '@tarekraafat/autocomplete.js';
import { mark } from '@tarekraafat/autocomplete.js/src/helpers/io';
import Tablesort from 'tablesort';

import { $Elements, BrowserEvents } from './constants';
import { fixMobileHover, wait } from './helpers';
import { calculateMenuOffset } from './menu';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- jQuery Related ----------

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {


		// ---------- Search (navbar) ----------

		$('.search-button').click(function() {
			$(this).toggleClass('show');
			$('#searchform .search-field').focus();
		});

		$('.close-search-btn').click(function() {
			$('.search-button').removeClass('show');
			$('#searchform .search-field').blur();
		});


		// ---------- Fix VH ----------

		$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
		$Elements.window.trigger('resize');

		// ---------- Fix Mobile Hover ----------

		fixMobileHover();

		// ---------- Links ----------

		$('a[href="#"], .void-link').click((e) => e.preventDefault());

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			const self = $(this);
			const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {

				$('html, body').stop().animate({
					scrollTop: calculateMenuOffset(target)
				}, 1000);
			}
		});

		$('.select-dropdown .dropdown-menu .btn').click(function() {
			$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
		});

		$('[target="lightbox"]').each(function() {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		});

		$('[target^="lightbox-gallery"]').each(function() {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		});

		$('.wine-table').each(function() {

			new Tablesort(this, {
				descending: true
			});
		});

		if(typeof wines_autocomplete_suggestions !== 'undefined') {

			$('.wine-search').each(function() {

				const wineAutoComplete = new autoComplete({
					name: 'wine-search',
					selector: () => this,
					diacritics: true,
					searchEngine: (query, record) => {

						const format = value => {
							value = value.toString().toLowerCase();

							return value
								.normalize('NFD')
								.replace(/[\u0300-\u036f]/g, '')
								.normalize('NFC')
								.replace(/[^a-zA-Z]/g, ' ')
								.replace(/\s\s+/g, ' ')
						};

						const nRecord = format(record);
						record = record.toString();
						query = format(query);

						let match = nRecord.indexOf(query);

						if(~match) {
							query = record.substring(match, match + query.length);
							match = record.replace(query, mark(query, true));

							return match;
						}
					},
					data: {
						src: wines_autocomplete_suggestions.suggestions,
						cache: true,
					},
					resultsList: {
						id: 'wine-search-list',
						class: 'list-group list-group-flush',
						maxResults: 6,
					},
					resultItem: {
						id: 'wine-search-result',
						class: 'list-group-item',
						highlight: true,
						element: (item, data) => {
							$(item).on('click', async function() {
								$(wineAutoComplete.input).val($(this).text());
								await wait(100);
								wineAutoComplete.close();
								$(wineAutoComplete.input).closest('form').submit();
							});
						},
					},
					events: {
						input: {
							focus: () => {
								if(wineAutoComplete.input.value.length) wineAutoComplete.start();
							}
						},
					},
				});
			});
		}
	});

}(jQuery));
